export const encounterDocs = [
  {
    encounterId: "292928",
    module: "documents",
    pageTitle: "Documents",

    subnav: [],

    sections: [
      {
        id: "documents-section",
        title: "Documents",
        tables: [
          {
            id: "documents-main",
            columns: [
              { key: "docName", header: "Document Name", sortable: true },
              { key: "docType", header: "Document Type" },
              { key: "docDate", header: "Scan Date" },
              { key: "docFileType", header: "File Type" },
              { key: "docUrl", header: "" },
            ],
            rows: [
              {
                docName: "Blood Test Results",
                docType: "Lab Report",
                docDate: "06/26/2017",
                docFileType: "PDF",
                docUrl:
                  "https://drive.google.com/file/d/1x35OBeK3G3qnQe24PVXeRUZJrEHwZ3oK/view?usp=drive_link",
              },
              {
                docName: "X-Ray Chest",
                docType: "Imaging (X-Ray)",
                docDate: "02/24/2017",
                docFileType: "JPEG",
                docUrl:
                  "https://drive.google.com/file/d/1XhX4_1KvCeDKjoF4lLy2FCk5Xm2XgbVE/view?usp=drive_link",
              },
              {
                docName: "Abdomen Scan",
                docType: "Imaging (CT Scan)",
                docDate: "02/10/2017",
                docFileType: "JPEG",
                docUrl:
                  "https://drive.google.com/file/d/1HOTRNVhyVTxqduJ5Lo5buUsdA6miOaAE/view?usp=drive_link",
              },
            ],
            ui: {
              searchable: true,
              downloadable: ["csv", "xls", "pdf"],
              downloadLinks: {
                csv: "https://drive.google.com/uc?export=download&id=12LaHzrtjq2NZ8uXuFJVkKph30ooPoNs8",
                pdf: "https://drive.google.com/uc?export=download&id=1l4MaCHDMzKO-3HK9-cVdZnsepLRn976W",
                xls: "https://docs.google.com/spreadsheets/d/1N_RoqcP5L4X7_13lEjePcI7mVZG3-P2C/export?format=xlsx",
              },
              defaultRowsPerPage: 10,
            },
          },
        ],
      },
    ],
  },
  {
    encounterId: "292929",
    module: "documents",
    pageTitle: "Documents",

    subnav: [],

    sections: [
      {
        id: "documents-section",
        title: "Documents",
        tables: [
          {
            id: "documents-main",
            columns: [
              { key: "docName", header: "Document Name", sortable: true },
              { key: "docType", header: "Document Type" },
              { key: "docDate", header: "Scan Date" },
              { key: "docFileType", header: "File Type" },
              { key: "docUrl", header: "" },
            ],
            rows: [
              {
                docName: "Blood Test Results",
                docType: "Lab Report",
                docDate: "06/26/2017",
                docFileType: "PDF",
                docUrl:
                  "https://drive.google.com/file/d/1x35OBeK3G3qnQe24PVXeRUZJrEHwZ3oK/view?usp=drive_link",
              },
              {
                docName: "X-Ray Chest",
                docType: "Imaging (X-Ray)",
                docDate: "02/24/2017",
                docFileType: "JPEG",
                docUrl:
                  "https://drive.google.com/file/d/1XhX4_1KvCeDKjoF4lLy2FCk5Xm2XgbVE/view?usp=drive_link",
              },
              {
                docName: "Abdomen Scan",
                docType: "Imaging (CT Scan)",
                docDate: "02/10/2017",
                docFileType: "JPEG",
                docUrl:
                  "https://drive.google.com/file/d/1HOTRNVhyVTxqduJ5Lo5buUsdA6miOaAE/view?usp=drive_link",
              },
            ],
            ui: {
              searchable: true,
              downloadable: ["csv", "xls", "pdf"],
              downloadLinks: {
                csv: "https://drive.google.com/uc?export=download&id=12LaHzrtjq2NZ8uXuFJVkKph30ooPoNs8",
                pdf: "https://drive.google.com/uc?export=download&id=1l4MaCHDMzKO-3HK9-cVdZnsepLRn976W",
                xls: "https://docs.google.com/spreadsheets/d/1N_RoqcP5L4X7_13lEjePcI7mVZG3-P2C/export?format=xlsx",
              },
              defaultRowsPerPage: 10,
            },
          },
        ],
      },
    ],
  },
  {
    encounterId: "292930",
    module: "documents",
    pageTitle: "Documents",

    subnav: [],

    sections: [
      {
        id: "documents-section",
        title: "Documents",
        tables: [
          {
            id: "documents-main",
            columns: [
              { key: "docName", header: "Document Name", sortable: true },
              { key: "docType", header: "Document Type" },
              { key: "docDate", header: "Scan Date" },
              { key: "docFileType", header: "File Type" },
              { key: "docUrl", header: "" },
            ],
            rows: [
              {
                docName: "Blood Test Results",
                docType: "Lab Report",
                docDate: "06/26/2017",
                docFileType: "PDF",
                docUrl:
                  "https://drive.google.com/file/d/1x35OBeK3G3qnQe24PVXeRUZJrEHwZ3oK/view?usp=drive_link",
              },
              {
                docName: "X-Ray Chest",
                docType: "Imaging (X-Ray)",
                docDate: "02/24/2017",
                docFileType: "JPEG",
                docUrl:
                  "https://drive.google.com/file/d/1XhX4_1KvCeDKjoF4lLy2FCk5Xm2XgbVE/view?usp=drive_link",
              },
              {
                docName: "Abdomen Scan",
                docType: "Imaging (CT Scan)",
                docDate: "02/10/2017",
                docFileType: "JPEG",
                docUrl:
                  "https://drive.google.com/file/d/1HOTRNVhyVTxqduJ5Lo5buUsdA6miOaAE/view?usp=drive_link",
              },
            ],
            ui: {
              searchable: true,
              downloadable: ["csv", "xls", "pdf"],
              downloadLinks: {
                csv: "https://drive.google.com/uc?export=download&id=12LaHzrtjq2NZ8uXuFJVkKph30ooPoNs8",
                pdf: "https://drive.google.com/uc?export=download&id=1l4MaCHDMzKO-3HK9-cVdZnsepLRn976W",
                xls: "https://docs.google.com/spreadsheets/d/1N_RoqcP5L4X7_13lEjePcI7mVZG3-P2C/export?format=xlsx",
              },
              defaultRowsPerPage: 10,
            },
          },
        ],
      },
    ],
  },
];
